import { routes as vProposalRoutes, ROUTES as PROPOSAL_ROUTES } from './proposal/router'

const routes = [
  {
    path: 'proposal/',
    component: () => import('./ProposalWrapper'),
    name: 'proposal-wrapper',
    meta: {
      requiresAuth: true
    },
    children: [
      ...vProposalRoutes
    ]
  }
]

const ROUTES = {
  ...PROPOSAL_ROUTES
}

export { routes, ROUTES }
